import { useState } from 'react';
import { Link } from 'react-router-dom';
import EditMenu from '../EditMenu';
import BellImage from '../../images/bell.png'

function ComposeNotiCard({text, market}) {

  return (
    <div className="col-span-full sm:col-span-6 xl:col-span-6 bg-white shadow-lg rounded-sm border border-gray-200 h-full w-full">
      <div className="flex flex-col h-full p-3">
        <div className="flex-grow pt-0 pb-0 px-2 mb-0">
          <div className="flex justify-between items-start h-full">
            <header className="h-full">
              <div className="flex mb-1 h-full my-auto">
                <div className="relative items-start mr-4 min-w-max my-auto">
                  <img className="flex-none rounded-full" src={BellImage} width="25" height="25" alt={''} />
                </div>
                <div className="mt-1 pr-1">
                  <div className="flex items-center"><span className="text-gray-500">{market}</span></div>
                  <div className="flex text-gray-800 hover:text-gray-900">
                    <h2 className="text-xl text-left">{text}</h2>
                  </div>
                </div>
              </div>
            </header>
            <div className="relative inline-flex flex-shrink-0 text-right">
              ✨
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComposeNotiCard;
